export const NEW_TAB_WINDOW_FEATURES = 'noopener,noreferrer';

export const shouldShowRowMenu = ({
  disableRowMenu = false,
  hasRowSelection = false,
  showRowMenuWithSelection = false,
  hasCustomContextMenu = false
}: {
  disableRowMenu?: boolean;
  hasRowSelection?: boolean;
  showRowMenuWithSelection?: boolean;
  hasCustomContextMenu?: boolean;
} = {}): boolean => !disableRowMenu && !hasCustomContextMenu && (!hasRowSelection || showRowMenuWithSelection);

export const shouldOpenRowUrlInNewTab = ({
  isExternalUrl,
  metaKey,
  ctrlKey
}: {
  isExternalUrl?: boolean;
  metaKey: boolean;
  ctrlKey: boolean;
}): boolean => Boolean(isExternalUrl || metaKey || ctrlKey);

export const getTableRowCopyId = (row: { id: string }): string => row.id;
